export enum BlockOutputType {
    Input = 'input',
    Dynamic = 'dynamic',
    Static = 'static',
    Custom = 'custom',
    None = 'none',
}
